import type { SalesDashboardComponentProps } from './SalesDashboardComponent';

export const SalesDashboardComponent = {
    MountAsync: async (target: HTMLElement, props: SalesDashboardComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { SalesDashboardComponent } = await import('./SalesDashboardComponent');
        return await mountReactComponentAsync(target, SalesDashboardComponent, props);
    }
};
